
import { portfolioColumnActionType } from '../../constants';

const PortfolioGroupAllocationColumnReducer = (state = [], action) => {
    switch (action.type) {
        case portfolioColumnActionType.FETCH_ALLOCATION_GROUP_COLUMN:
            return action.payload;
        default:
            return state;
    }
};
export default PortfolioGroupAllocationColumnReducer